export const mapCompilationFormData = (data, media) => ({
  title: data?.title,
  autoInclude: data?.autoInclude,
  ctaLabel: data?.ctaLabel,
  ctaLink: data?.ctaLink,
  ctaDescription: data?.ctaDescription,
  websiteLink: data?.websiteLink,
  enabled: data?.enabled,
  sort: data?.sort,
  content: contentMapper(media || data?.media)
});

const contentMapper = (media) => media?.map((m) => m?.id);



// WEBPACK FOOTER //
// ./src/helpers/compilationHelper.js